/**
 * View-preferences module API client — thin wrapper over fetchApi.
 *
 * Every call lands on `/v1/users/me/view-preferences/:viewKey`. fetchApi
 * attaches the correct (token, workspaceId) pair based on the current
 * api-mode (Live vs Demo), so demo sessions get their own preference
 * row keyed by the demo workspace.
 *
 * BE: Redis hash at view-pref:{userId}:{workspaceId} (sliding 180d TTL),
 * see src/modules/view-preferences/ in the new backend.
 */
import { fetchApi, ApiClientError } from '@/lib/api/client';

export { ApiClientError as ApiError };

export async function viewPreferencesFetch<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  const endpoint = `/users/me/view-preferences/${cleanPath}`;
  return fetchApi<T>(endpoint, options as RequestInit & { skipAuth?: boolean });
}
